module.exports = ["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]


//////////////////
// WEBPACK FOOTER
// ./~/html-void-elements/index.json
// module id = 197
// module chunks = 96961042003272 139266963665775